import React from 'react';

// -----------------------------------------------------------
//  ProductVideo
// -----------------------------------------------------------
const ProductVideo = (props) => {
  return (
    <video className="img-fluid"
           poster={props.thumbnail}
           type="video/mp4"
           src={props.url}
           autoPlay
           loop
           muted
           playsInline />
  );
}

export default ProductVideo;
